<form name="form">
    <button type="submit" class="btn btn-secondary" (click)="fileButton.click()" translate>
        Upload csv file
    </button>
    <input type="file" #fileButton id="new_bulk_csv" [attr.accept]="'.csv'" (change)="newBulkFile($event)" class="hidden">

    <!-- CSV Format Information -->
    <div class="csv-format-info mt-4">
        <h5 translate>CSV Format</h5>
        
        <div class="row">
            <div class="col-md-24">
                <div class="card">
                    <div class="card-header">
                        <h6 class="mb-0" translate>Required Columns</h6>
                    </div>
                    <div class="card-body">
                        <p class="small" translate>Your CSV file must include the following columns:</p>
                        <ul class="small mb-2">
                            <li><strong>url</strong> - <span translate>The domain URL (e.g., https://example.com)</span></li>
                            <li><strong>title</strong> - <span translate>The domain name/title</span></li>
                        </ul>
                        
                        <strong translate>Example:</strong>
                        <pre class="mt-2">url,title
https://example.com,Example Domain
https://example.org,Example Organization
https://example.net,Example Network</pre>
                        
                        <small class="text-muted" translate>Column headers are case-insensitive. You will map your CSV columns to these fields in the next step.</small>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="alert alert-info mt-3">
            <small>
                <strong translate>Note:</strong> 
                <span translate>The first row of your CSV should contain column headers. Domain settings (scan configuration, features, etc.) will be configured in later steps and applied to all imported domains.</span>
            </small>
        </div>
    </div>
</form>
